import { IPaginationResponse } from '../../../../core';
import { IAttachmentDownloadUrlResponse, IAttachmentResponse } from '../dtos';

const attachmentResponse: IAttachmentResponse = {
  id: '7bd3e96d-0944-41d4-8e76-586a13542275',
  name: 'TESt',
  size: 5412
};

const attachmentsResponse: IPaginationResponse<IAttachmentResponse> = {
  items: [
    {
      id: '7bd3e96d-0944-41d4-8e76-586a13542275',
      name: 'TESt',
      size: 5412
    },
    {
      id: 'ceb61384-9399-424e-8c42-2edcd3313483',
      name: 'TESt',
      size: 5412
    },
    {
      id: '8aa3f251-ec76-4409-8e0a-54c6c567dda2',
      name: 'TESt',
      size: 5412
    },
    {
      id: 'c02e2a8c-33a2-40ef-96d9-1a7da4b8bf29',
      name: 'TESt',
      size: 5412
    },
    {
      id: '5634f64d-99d1-4190-bc0e-200f42d91344',
      name: 'TESt',
      size: 5412
    },
    {
      id: '306005ef-d065-47b7-a667-7310f67d4ed3',
      name: 'TESt',
      size: 5412
    },
    {
      id: 'ca733b2c-5320-48aa-9d39-d637176fd068',
      name: 'TESt',
      size: 5412
    },
    {
      id: 'ef2bfce0-2745-41d4-8961-cb68c3a75c50',
      name: 'TESt',
      size: 5412
    },
    {
      id: '2dcde0f8-a77e-403a-bcb3-a4fc6b266114',
      name: 'TESt',
      size: 5412
    },
    {
      id: '14bbc0fa-1495-4c92-86e9-eb876100707c',
      name: 'TESt',
      size: 5412
    }
  ],
  paginationMetadata: {
    totalItemCount: 11706,
    numberOfPages: 1171,
    pageSize: 10,
    order: 'Ascending',
    page: 1,
    hasNext: true,
    hasPrevious: false
  }
};

const attachmentDownloadUrlResponse: IAttachmentDownloadUrlResponse = {
  name: 'TESt',
  size: 5412,
  downloadUrl: '7bd3e96d-0944-41d4-8e76-586a13542275',
};

const attachmentCreateResponse: string = '7bd3e96d-0944-41d4-8e76-586a13542275';

export const attachmentsData = {
  attachmentResponse,
  attachmentsResponse,
  attachmentCreateResponse,
  attachmentDownloadUrlResponse
};
